import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from '../common/global-constants';
import { SharedService } from './shared.service';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})

export class ComplaintService {

  constructor(private sharedapi: SharedService, private http: HttpClient) { }

  getAllComplaintList()
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-all-complaint-list',{headers:webheader})
  }

  addComplaint(data){
    var formData: any = new FormData();
    for (const key in data)
    {
        formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-ipd-complaint',formData,{headers:webheader})
  }

  updateComplaint(data)
  {
    var formData: any = new FormData();
    for (const key in data)
    {
        formData.append(key, data[key]);
    }
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-ipd-complaint',formData,{headers:webheader})
  }
  
  getComplaintData(data){
    let ipd_id = data.ipd_id;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-ipd-complaint-details/'+ipd_id,{headers:webheader})
  }

  getComplaintsList(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-complaints/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }


  getUserComplaint(data){
    let ipd_id = data.ipd_id;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-user-wise-complaint/'+ipd_id,{headers:webheader})
  }


  addComplaintAction(data){
    // let webheader = this.sharedapi.getHeaders();
    // return this.http.post(apiUrl+'add-complaint-action-data',data,{headers:webheader})
    var formData: any = new FormData();
    for (const key in data)
    {
        formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-complaint-action-data',formData,{headers:webheader})
  }


  viewIpdDetails(ipd_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'view-ipd-complaint-list/'+ipd_id,{headers:webheader})
    }

  


}
